import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import errorBoundary from '@ifeng/errorBoundary';
import FengHeader from './fengHeader/';
import Content from './content/';
import FengFooter from './fengFooter/';
import Totop from '../../../components/toTop/';

const Layout = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };

        render() {
            const {
                content: {
                    search,
                    logo,
                    footer,
                    ad_top_banner,
                    ad_right_rec1,
                    ad_right_rec2,
                    ad_right_rec3,
                    ad_content_banner1,
                    ad_content_banner2,
                    ad_bottom_banner,
                    docData,
                    recWeChatQrCode,
                    brandLogo,
                    qrCodeLogo,
                    rightGameAd,
                    type,
                    wemediaDetail = {},
                },
            } = this.props;

            const headerData = {
                search,
                ad_top_banner,
                logo,
            };

            const contentData = {
                type,
                docData,
                recWeChatQrCode,
                brandLogo,
                qrCodeLogo,
                ad_right_rec1,
                ad_right_rec2,
                ad_right_rec3,
                ad_content_banner1,
                ad_content_banner2,
                rightGameAd,
                wemediaDetail,
            };

            const footerData = {
                footer,
                ad_bottom_banner,
            };

            return (
                <Fragment>
                    {/* 头部全站导航，广告，logo，搜索，频道导航 */}
                    <FengHeader content={headerData} />
                    {/* 中间内容部部分 */}
                    <Content content={contentData} />
                    {/* 尾部合作链接、全站通用尾 */}
                    <FengFooter content={footerData} />
                    <Totop />
                    <ChipEdit transform={transform} />
                </Fragment>
            );
        }
    },
);

export { Layout };
export default Layout;
